import SwimlaneModel from '../../pages/map-level/SwimlaneModel';

const SwimlaneResolver = () => {
  return <SwimlaneModel />;
};

export default SwimlaneResolver;
